import React, { memo } from 'react';
import PropTypes from 'prop-types';
import isNil from 'ramda/src/isNil';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Rating from '@components/@core/Rating';
import { getUnit } from '~/services/util';
import { QUOTA_TYPES } from '~/services/constants';

const Quota = ({ 
    index = 0, 
    data = {
        id: 0,
        name: '',
        data: {},
    }, 
    editable = false, 
    onChange = () => {}, 
    onSelect = () => {} 
}) => {
    const dotsMenu = data.stars?.length > 0 || data.star_values ? ['Move Up', 'Move Down', 'Remove', 'Edit'] : ['Move Up', 'Move Down', 'Remove'];
    const stars = isNil(data.stars) ? data.star_values : data.stars;
    const quotaUnit = QUOTA_TYPES[data.quota_value ?? 0];

    return (
        <div className={`d-flex py-3 ${index > 0 ? 'border-line' : ''}`}>
            <div className="d-flex-10 pe-4">
                <p className="dsl-b16 mb-1 text-400 truncate-one">{data.name}</p>
                <p className="dsl-m16 mb-0 truncate-two">{data.data.description}</p>
                <p className="d-none dsl-m12 mb-0 quota-unit">Actual : {quotaUnit}</p>
            </div>
            <div className="d-flex-4">
                <p className="dsl-b16 my-1">{quotaUnit}</p>
            </div>
            {stars ? (
                <div className="d-flex-4">
                    <div className="d-flex">
                        <p className="dsl-b16 mb-0 w-25 me-3 ssm-r-2">{getUnit(stars[5], quotaUnit)}</p>
                        <Rating score={5} />
                    </div>
                    <div className="d-flex">
                        <p className="dsl-b16 mb-0 w-25 me-3 ssm-r-1">{getUnit(stars[4], quotaUnit)}</p>
                        <Rating score={4} />
                    </div>
                    <div className="d-flex">
                        <p className="dsl-b16 mb-0 w-25 me-3 ssm-r-1">{getUnit(stars[3], quotaUnit)}</p>
                        <Rating score={3} />
                    </div>
                    <div className="d-flex">
                        <p className="dsl-b16 mb-0 w-25 me-3 ssm-r-1">{getUnit(stars[2], quotaUnit)}</p>
                        <Rating score={2} />
                    </div>
                    <div className="d-flex">
                        <p className="dsl-b16 mb-0 w-25 me-3 ssm-r-1">{getUnit(stars[1], quotaUnit)}</p>
                        <Rating score={1} />
                    </div>
                    <div className="d-flex">
                        <p className="dsl-b16 mb-0 w-25 me-3 ssm-r-1">{getUnit(stars[0], quotaUnit)}</p>
                        <Rating score={0} />
                    </div>
                </div>
            ) : (
                <div className="d-flex-4 d-h-end">
                    <Button className="px-4" type="link" name="+ Add Scale" onClick={() => onChange('stars', [])} />
                </div>
            )}
            <div className="edit d-flex-1 d-h-end">{editable && <EditDropdown options={dotsMenu} onChange={onSelect} />}</div>
        </div>
    );
};

Quota.propTypes = {
    index: PropTypes.number,
    editable: PropTypes.bool,
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        data: PropTypes.any,
    }),
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
};

export default memo(Quota);
